import React, {useContext} from "react";
import {injectIntl} from "react-intl";
import UIPopupContext from "../UIPopupContext";


const ReferralPopupSearchInput = (props) => {

  const {intl, searchProperty} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const handleInputChange = async (event) => {
    uiPopupDispatch({[searchProperty]: event.target.value})
  }

  return (
    <input className="fabricators-popup-search__input mb-05 fabricators-popup-search__input--small"
           placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
           value={uiPopupContext[searchProperty] || ""}
           onChange={handleInputChange}/>
  )
};

export default injectIntl(ReferralPopupSearchInput)
